import { Euro } from "@mui/icons-material";
import { MenuItem, Stack, TextField, Button } from "@mui/material";
import { useState } from "react";
import Course from "../../Inputs/Course";

export default function ItemForm({onSubmit, onCancel}){

    const [item, setItem] = useState({...defaultItem})

    
    const handleSubmit = e => {
        e.preventDefault();
        onSubmit(item);
        setItem({...defaultItem})
    }


    return <form onSubmit={handleSubmit} width={300}>

        <Stack direction='column' spacing={2}>


            <TextField
                label="Ajouter un article"
                value={item.class}
                onChange={e => setItem({...defaultItem, 
                    class: e.target.value
                })}
                select
                required
                size='small'
            >
                <MenuItem value='course'>Formation</MenuItem>
                <MenuItem value='other'>Autre</MenuItem>
            </TextField>

            
            {item.class === 'other' && 
                <TextField
                    label='Désignation'
                    value={item.title || ''}
                    onChange={e => setItem({...item, 
                        title: e.target.value, 
                        code: Date.now().toString()
                    })}
                    inputProps={{maxLength: 250}}
                    required
                    size='small'
                />
            }

            {item.class === 'course' &&

                <Course
                    value={item.course}
                    onChange={course => setItem({...item, 
                        title: course?.title, 
                        code: course?.id,
                        course: course
                    })}
                    required
                />
            }

            <TextField
                label='Prix unitaire'
                type='number'
                value={item.price || ''}
                onChange={e => setItem({...item, price: parseFloat(e.target.value || 0)})}
                InputProps={{
                    inputProps: {step: 0.01},
                    endAdornment: <Euro color='action'/>
                }}
                required
                size='small'
            />

            <TextField
                label='Quantité'
                type='number'
                value={item.quantity || ''}
                onChange={e => setItem({...item, quantity: parseInt(e.target.value || 0)})}
                InputProps={{
                    inputProps: {min: 1, step: 1},
                }}
                required
                size='small'
            />

            <TextField
                label="Taux de TVA"
                value={item.taxRate.toFixed(3)}
                onChange={e => setItem({...item, taxRate: parseFloat(e.target.value)})}
                select
                required
                size='small'
            >
                <MenuItem value='0.000'>0%</MenuItem>
                <MenuItem value='0.055'>5.5%</MenuItem>
                <MenuItem value='0.100'>10%</MenuItem>
                <MenuItem value='0.200'>20%</MenuItem>
            </TextField>

            
            <Stack direction='row' justifyContent='flex-end' spacing={3}>

                <Button
                    color='error'
                    onClick={onCancel}
                    size='large'
                >
                    Annuler
                </Button>

                <Button
                    type='submit'
                    size='large'
                >
                    Ajouter    
                </Button>

            </Stack>

        </Stack>

    </form>

}


const defaultItem = {
    class: 'course',
    price: 0,
    taxRate: 0,
    quantity: 1,
};